module.exports = require('./parseStateSlicer')
